import React from 'react'
import { Stack, Table, Text } from '@mantine/core'
import { useTheme } from '../../../../components/ThemeProvider'

type Props = {
  data: any
}

const fields = [
  { label: '金融风险', key: 'bad_info_detail_score_A_1' },
  { label: '侵犯财产风险', key: 'bad_info_detail_score_A_2' },
  { label: '人身权利风险', key: 'bad_info_detail_score_A_3' },
  { label: '涉赌风险', key: 'bad_info_detail_score_A_4' },
  { label: '安全危害风险', key: 'bad_info_detail_score_A_5' },
  { label: '公共妨碍风险', key: 'bad_info_detail_score_A_6' },
  { label: '其他风险', key: 'bad_info_detail_score_A_7' },
]

const renderValue = (value: string, warningColor: string, primaryColor: string) => {
  const isRisk = value !== '0'
  return (
    <Text size="sm" fw={600} style={{ color: isRisk ? warningColor : primaryColor }}>
      {isRisk ? '存在风险' : '暂无风险'}
    </Text>
  )
}

export default function CriminalRecordRiskTable({ data }: Props) {
  const theme = useTheme()

  return (
    <Stack gap="sm">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        前科风险扫描
      </Text>
      <Table
        highlightOnHover
        verticalSpacing="sm"
        withColumnBorders={false}
        styles={{
          table: { fontSize: '13px', tableLayout: 'fixed' },
          th: {
            backgroundColor: theme.surfaceMutedColor,
            color: theme.accentTextColor,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '40%' }}>风险类型</Table.Th>
            <Table.Th style={{ width: '60%' }}>结果</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {fields.map((field) => (
            <Table.Tr key={field.key}>
              <Table.Td>{field.label}</Table.Td>
              <Table.Td>{renderValue(data?.[field.key], theme.warningColor, theme.primaryColor)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  )
}
